import constants from '../../../Constants';
import interactionParserUtils from './InteractionParserUtils';

const drawingParser = {
    parse(interaction, language, defaultLanguage) {
        const prompt = interactionParserUtils.getPrompt(interaction, language, defaultLanguage);
        const allowOrientationOverride = interaction.getAttribute('inspera:allowOrientationOverride') === 'true';
        const maxHeight = parseInt(interaction.getAttribute('maxHeight'), 10);
        const maxWidth = parseInt(interaction.getAttribute('maxWidth'), 10);
        const interactionType = (interaction?.nodeType === 1) ? interaction.localName : null;
        const responseIdentifier = interaction.getAttribute('responseIdentifier');

        const extraResponseDeclarations = [
            {
                baseType: 'file',
                cardinality: 'single',
                identifier: `${responseIdentifier}_jsonId`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileName`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileType`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileSize`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_drawingBase64`,
            },
            {
                baseType: 'string',
                cardinality: 'single',
                identifier: `${responseIdentifier}_jsonData`,
            },
            {
                baseType: 'boolean',
                cardinality: 'single',
                identifier: `${responseIdentifier}_pendingSync`,
            },
            {
                baseType: 'uri',
                cardinality: 'single',
                identifier: `${responseIdentifier}_fileURI`,
            },
            {
                baseType: 'uri',
                cardinality: 'single',
                identifier: `${responseIdentifier}_jsonDataURI`,
            },
        ];

        return {
            allowOrientationOverride: allowOrientationOverride || false,
            extraResponseDeclarations,
            maxHeight: maxHeight || 1123,
            maxWidth: maxWidth || 794,
            prompt,
            responseIdentifier,
            type: constants.interactionType.DRAWING_INTERACTION,
            interactionType,
        };
    },
};

export default drawingParser;
